<template>
    <l-map :style="styling" :zoom="zoom" :center="[lat, lng]" :options="leafletMapOptions">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-marker :lat-lng="[lat, lng]"></l-marker>
    </l-map>
</template>

<script>
import {latLng} from 'leaflet';
import {LMap, LTileLayer, LMarker} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

// Marker icon/webpack issue: https://vue2-leaflet.netlify.app/quickstart/#marker-icons-are-missing
import {Icon} from 'leaflet';
import Latvian from "vue-tailwind/dist/l10n/lv";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    props: {
        lat: Number,
        lng: Number,
        zoom: Number,
        width: Number,
        height: Number,
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
    },
    data() {
//        console.log( process.env.MIX_MAP_TILE_SOURCE);
//        console.log( process.env.MIX_MAP_ATTRIBUTION);
        return {
//            url: process.env.MIX_MAP_TILE_SOURCE,
//            attribution: process.env.MIX_MAP_ATTRIBUTION,
            url: 'https://api.maptiler.com/maps/openstreetmap/{z}/{x}/{y}.jpg?key=vvfZdSifoPLZoTnpb6pM',
            attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
            markerLatLng: [this.lat, this.lng],
            leafletMapOptions: {
                scrollWheelZoom: false
            }
        };
    },
    computed: {
        styling() {
            return `width: ${this.width}px; height: ${this.height}px;`
        }
    }
}
</script>
